import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UpdateRunStatusParams, IRunManagementAPI } from './definitions';
import { environment } from '@env/environment';

export class RunManagementAPI implements IRunManagementAPI {
  private apiUrl: string;

  public constructor(private http: HttpClient, private baseUrl: string) {
    this.baseUrl = `${environment.apiUrl}/runs`;
  }

  public updateRunStatus(params: UpdateRunStatusParams) {
    const method = 'PATCH';
    const url = `${this.baseUrl}/`;

    return of({});
  }

  public get() {
    const url = `${this.baseUrl}/run-search`;
    return this.http.get(url);
  }
}
